<template>
    <div class="recover-password-form">
        <h2>Recuperar senha</h2>

        <div class="text-link">
            <span>Insira seu e-mail para criar uma nova senha.</span>
        </div>

        <div>
            <b-form @submit.stop.prevent="onSubmit" novalidate>
                <b-form-group>
                    <b-form-input
                        id="email"
                        v-model="$v.form.email.$model"
                        type="email"
                        placeholder="Digite seu e-mail"
                        :state="validateState('email')"
                    ></b-form-input>

                    <b-form-invalid-feedback :state="validateState('email')">
                        Digite um e-mail válido
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-button type="submit" :variant="getIsDarkTheme ? 'primary' : 'dark'" class="radius-6 submit"
                    >Recuperar</b-button
                >
            </b-form>
        </div>

        <b-modal
            ref="warning-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
        >
            <div class="content">
                <SuccessMsgModal :msg="message" />
            </div>

            <div class="footer-buttons">
                <b-button variant="primary" @click="hideModal('warning-modal-ref')">Entendi</b-button>
            </div>
        </b-modal>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import SuccessMsgModal from '@/ui/modal/success-msg-modal/SuccessMsgModal'
import { AuthenticationApi } from '../../api/authentication'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'

const authenticationApi = new AuthenticationApi()

export default {
    components: { SuccessMsgModal, DangerModalPP },
    data() {
        return {
            message: null,
            form: {
                email: null
            }
        }
    },
    validations: {
        form: {
            email: { required, email }
        }
    },
    computed: {
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        }
    },
    methods: {
        ...mapActions(['setIsLoading']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            const data = { email: this.form.email }
            this.setIsLoading(true)

            authenticationApi
                .forgotPassword(data)
                .then(response => {
                    this.message = response.data.message
                    this.form.email = null
                    this.$v.form.$reset()
                    this.showModal('warning-modal-ref')
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        }
    }
}
</script>

<style scope src="./RecoverPasswordForm-light-theme.css"></style>
<style scope src="./RecoverPasswordForm-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/components/recover-password-form/RecoverPasswordForm.vue